import { TableCell, TableRow } from '@/components/ui';
import { FieldValue } from '../field-value';
import { useDocumentRow } from './use-document-row';

export function DocumentRow(props: Parameters<typeof useDocumentRow>[0]) {
  const f = useDocumentRow(props);

  return (
    <TableRow onClick={f.handleRowClick} className="cursor-pointer hover:bg-muted/50">
      <TableCell className="text-right bg-muted/20 text-muted-foreground font-medium select-none">
        {f.rowNumber}
      </TableCell>
      <TableCell className="font-mono text-xs">{f.documentId}</TableCell>
      {f.cells.map((cell) => (
        <TableCell
          key={cell.fieldName}
          onClick={
            cell.isClickable
              ? (e) => f.handleCellClick(e, cell.fieldName, cell.value, cell.peekType)
              : undefined
          }
          className={cell.isClickable ? 'cursor-pointer' : ''}
        >
          <FieldValue
            value={cell.value}
            onPeek={
              cell.isClickable && cell.peekType
                ? (val, type) => props.onPeek?.(val, type, cell.fieldName)
                : undefined
            }
          />
        </TableCell>
      ))}
    </TableRow>
  );
}
